import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import * as Sentry from '@sentry/angular';
import { AppRoutingModule } from './app-routing.module';
import { SharedCoreModule } from './shared/shared-core.module';

import { AppComponent } from './app.component';

import {
  HTTP_INTERCEPTORS,
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { TokenInterceptor } from './core/interceptors/token.interceptor';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { MatomoModule, MatomoRouterModule } from 'ngx-matomo-client';
import { Observable } from 'rxjs';
import { DialogService } from './core/services/dialog.service';
import { FavoritesService } from './core/services/favorites.service';
import { AuthModule } from './features/auth/auth.module';

export class VersionedTranslateLoader implements TranslateLoader {
  constructor(private http: HttpClient) {}

  getTranslation(lang: string): Observable<any> {
    const version = environment.translationVersion;
    const path = `assets/i18n/${lang}.json?v=${version}`;
    return this.http.get(path);
  }
}
export function translateLoaderFactory(http: HttpClient) {
  return new VersionedTranslateLoader(http);
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    SharedCoreModule,
    AppRoutingModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: translateLoaderFactory,
        deps: [HttpClient],
      },
    }),
    MatomoModule.forRoot({
      siteId: environment.matomo.siteId,
      trackerUrl: environment.matomo.trackerUrl,
      requireConsent: 'tracking',
      disabled: !environment.matomo.trackerUrl,
    }),
    MatomoRouterModule
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    // Routes uncaught client-side errors to GlitchTip (no-op when Sentry.init
    // is disabled, e.g. dev or missing DSN).
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    FavoritesService,
    DialogService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
